import { ProjectListFilter } from '../../../generated/graphql'
import { reduceToSum } from '../../../util/array-utility'
import { getIsoStringAtStartOfDay } from '../../common/util/date-util'

export type ProjectForAreaCalculation = {
  versions: {
    isDefault: boolean
    buildings: { area: number; multiplier: number }[]
  }[]
}

/** Calculate the total area of all the buildings in the default version of the project */
export const calculateArea = (project: ProjectForAreaCalculation): number => {
  const defaultVersion = project.versions.find((v) => v.isDefault)
  return (
    defaultVersion?.buildings
      .map((b) => b.area * b.multiplier)
      .reduce(reduceToSum, 0) ?? 0
  )
}

export const createProjectListFilter = (
  count: number,
  offset = 0,
  keyword?: string,
  createdAfter?: Date,
): { filter: ProjectListFilter } => ({
  filter: {
    offset,
    count,
    keyword,
    createdAfter: getIsoStringAtStartOfDay(createdAfter),
  },
})
